export function InputSection(props: {
	children: React.ReactNode;
	title: React.ReactNode | string;
}) {
	return (
		<div>
			<div className="">
				<h3 className="rounded-t-md  bg-base-dark p-4 text-lg font-bold">
					{props.title}
				</h3>
			</div>
			<div className="rounded-b-md bg-base-semidark px-4 pb-8">
				{props.children}
			</div>
		</div>
	);
}
